import loadable from '@loadable/component';

const Header = loadable(() => import('./Header'));
export default Header;
